import { render } from "./EditTheme.vue?vue&type=template&id=4e5c3b96&ts=true"
import script from "./EditTheme.vue?vue&type=script&lang=ts"
export * from "./EditTheme.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__